  <!--Loading Spinner-->
  <div *ngIf="isLoading">
    <app-spinner></app-spinner>
  </div>

  <!-- Content Header (Page header) -->
  <section class="content-header">
      <div class="content-header">
          <div class="container-fluid">
            <div class="row mb-2">

              <div class="col-sm-6">

              </div><!-- /.col -->

              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
                  <li class="breadcrumb-item active">Delete NEMA Payments</li>
                </ol>
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div><!-- /.container-fluid -->
      </div>

      <div class="row">
        <div class="col-md-8">
            <div class="row">

            </div>
        </div>
        <div class="col-md-4">
          <div class="row">
              <div class="col">
                  <input type="text" class="form-control" placeholder="Search by Chassis Number or BL Number" (input)="onSearchTextChange($event)">
              </div>
          </div>
        </div>
      </div>
      </section>
        <!-- /.content-header -->
      <section class="content">
        <div class="container-fluid">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Delete NEMA Payments</h3>
              <!--Error Message-->
              <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
                {{errorMessage}}
              </div>
              <!--Success Message-->
              <div class="alert alert-success" role="alert" *ngIf="successMessage">
                {{successMessage}}
              </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <table id="example1" class="table table-bordered table-hover">
                <thead>
                  <tr>
                      <th>Posted On</th>
                      <th>BL No.</th>
                      <th>Make</th>
                      <th>Model</th>
                      <th>Chassis No.</th>
                      <th>Amount</th>
                      <th></th>
                  </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let vehicle of deletablePayments | searchEditablePayments: searchText| paginate: { itemsPerPage: 10, currentPage: page, totalItems: count }">
                      <td>{{vehicle.posted_on| date:'dd-MM-yyyy'}}</td>
                      <td>{{vehicle.bl_no}}</td>
                      <td>{{vehicle.make_name}}</td>
                      <td>{{vehicle.model_name}}</td>
                      <td>{{vehicle.chassis_no}}</td>
                      <td>{{vehicle.amount | number}}</td>
                      <td><a (click)="deleteNEMA_Payment(vehicle.id,vehicle.vehicle_id,vehicle.chassis_no,vehicle.amount)" class="btn btn-danger btn-sm" role="button" aria-pressed="true"><i
                        class="fa fa-trash" aria-hidden="true">&nbsp;</i>Delete</a></td>
                    </tr>
                </tbody>
              </table>
              <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
            </div>
            <!-- /.card-body -->
          </div>
        </div>
      </section>
